import { Box } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { commonStyle } from '../../../../common/styles';
import { LanguageContext } from '../../../../context/LanguageContextProvider';

const MESSAGE =
  '到着時間は目安です。\n混雑状況で表示内容と異なる場合があります。';

const MESSAGE_EN =
  'Arrival times are estimates only.\nIt may differ from the actual due to congestion.';

export const Note: React.FC = () => {
  const { language } = useContext(LanguageContext);
  return (
    <Box
      w='100%'
      h='100%'
      bgColor='#f0f8ff'
      fontSize='11px'
      fontWeight='bold'
      padding='0 10px 0 10px'
      whiteSpace='pre-wrap'
      sx={{ ...commonStyle.justifyStart }}
    >
      {language === 'en' ? MESSAGE_EN : MESSAGE}
    </Box>
  );
};
